import EmptyRouterView from '@/views/CuttingJobs/Index.vue'
import CuttingJobs from '@/views/CuttingJobs/CuttingJobs'
export default [
    {
        path: '/cuttingJobs',
        component: EmptyRouterView,
        meta: {
            title: 'Zlecenia docięcia',
            menuRendered: true,
            menuTitle: 'Zlecenia docięcia',
            requiresAuth: true,
            permission: 'cutting_jobs',
            icon: 'mdi-content-cut',
        },
        children: [
            {
                path: '',
                name: 'CuttingJobs',
                component: CuttingJobs,
                meta: {
                    title: 'Zlecenia docięcia',
                    requiresAuth: true,
                    permission: 'cutting_jobs',
                },
            },
        ],
    }
]
